import React from 'react';

const RequiredFieldIndicator = () => (
  <abbr title="required" className="usa-hint usa-hint--required">
    *
  </abbr>
);

export default RequiredFieldIndicator;
